const initProductsSlider = () => {
  const slider = document.querySelector('[data-slider="products"]');

  if (!slider) {
    return;
  }

  const cards = document.querySelector('[data-cards]');
  const buttons = cards.querySelectorAll('[data-cards-button]');

  let activeSlideIndex;

  for (let i = 0; i < buttons.length; i++) {
    if (buttons[i].classList.contains('is-active')) {
      activeSlideIndex = i;
      break;
    }
  }

  const swiper = new Swiper(slider, {
    initialSlide: activeSlideIndex,
    slidesPerView: "auto",
    spaceBetween: 30,
    slideToClickedSlide: true,
  });
};

export { initProductsSlider };
